import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class EntitySchemaDataService extends DataService<typeof Model.Core.Logic.ViewModels.EntitySchemaItem, Model.Core.Logic.ViewModels.EntitySchemaItem, EntitySchemaSummary> {
	protected map(entity: Model.Core.Logic.ViewModels.EntitySchemaItem): EntitySchemaSummary {
		return new EntitySchemaSummaryModel(entity);
	}

	static make(context?: any): EntitySchemaDataService {
		return new EntitySchemaDataService(context, ctx => ctx.EntitySchemas);
	}
}

export class EntitySchemaSummaryModel extends EntityModel<Model.Core.Logic.ViewModels.EntitySchemaItem, EntitySchemaSummary> implements EntitySchemaSummary {
	@property<EntitySchemaSummaryModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	public name: string;

	@property<EntitySchemaSummaryModel>(o => o.entity.schema, (o, value) => o.entity.schema = value)
	public schema: string;

	@property<EntitySchemaSummaryModel>(o => o.entity.isEditable, (o, value) => o.entity.isEditable = value)
	public isEditable: boolean;

	@property<EntitySchemaSummaryModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: number;
}



// WEBPACK FOOTER //
// ./src/app/general/entity-schemas/entity-schema.data.ts